import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/about_top.png';
import _imports_1 from '../assets/about1.png';
import _imports_2 from '../assets/about_bg2.png';
import _imports_3 from '../assets/about_bg4.png';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-2bec83f8"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "about"
};

var _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"title\" data-v-2bec83f8><img src=\"" + _imports_0 + "\" alt=\"\" data-v-2bec83f8></div><div class=\"title_lb\" data-v-2bec83f8> 公司介绍 </div><div class=\"cont1\" data-v-2bec83f8><img src=\"" + _imports_1 + "\" alt=\"\" data-v-2bec83f8><p class=\"text\" data-v-2bec83f8> “芝士未来”（品牌隶属于北京芝士未来科技有限公司）通过对于教育行业、数据、技术的深刻理解，依托数年深耕金融行业的资源优势，利用大数据分析 和机器学习等人工智能风控技术来提高公司的核心竞争力，形成了独特且完善的信用审核、风险控制体系， 为广大用户提供完美体验的系统服务，为年轻人的合理消费提供多方位支持。 </p></div><div class=\"cont2\" data-v-2bec83f8><div class=\"title_lb cont2tit\" data-v-2bec83f8> 发展历程 </div><img class=\"cont2_bg\" src=\"" + _imports_2 + "\" alt=\"\" data-v-2bec83f8></div>", 4);

var _hoisted_6 = {
  class: "cont2 callme"
};

var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "title_lb cont2tit"
  }, " 联系我们 ", -1);
});

var _hoisted_8 = {
  class: "mapbox cl"
};

var _hoisted_9 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "txtbox fl"
  }, [/*#__PURE__*/_createElementVNode("p", null, "联系电话：4001150667"), /*#__PURE__*/_createElementVNode("p", null, "服务邮箱：service@zhishiweilai.com "), /*#__PURE__*/_createElementVNode("p", null, "合作邮箱：BD@zhishifenqi.com"), /*#__PURE__*/_createElementVNode("p", null, "地       址：北京市朝阳区北辰世纪中心A座"), /*#__PURE__*/_createElementVNode("p", null, "邮       编：100089")], -1);
});

var _hoisted_10 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    class: "cont2_bg",
    src: _imports_3,
    alt: ""
  }, null, -1);
});

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_6, [_hoisted_7, _createElementVNode("div", _hoisted_8, [_hoisted_9, (_openBlock(), _createElementBlock("div", {
    id: "container",
    class: "fr",
    key: new Date().getTime()
  }))]), _hoisted_10])]);
}